<div class="register">
  <div class="col-12 form" [formGroup]="registerForm">
    <div>
      <label for="username" class="visually-hidden">Enter username</label>
      <input
        type="text"
        autocomplete="nickname"
        placeholder="Username"
        class="input-text"
        formControlName="username"
        required
      />
      <label for="username" class="visually-hidden">Enter email</label>
      <input
        type="email"
        autocomplete="email"
        placeholder="Email"
        class="input-text"
        formControlName="email"
        required
      />

      <label for="password" class="visually-hidden">
        Enter & Confirm Password
      </label>
      <input
        type="password"
        autocomplete="new-password"
        placeholder="Password"
        class="input-text"
        formControlName="password"
        required
      />
      <input
        type="password"
        autocomplete="new-password"
        placeholder="Repeat password"
        class="input-text"
        formControlName="password_again"
        required
      />
      <password-strength-meter
        [password]="registerForm.get('password').valueChanges | async"
        [enableFeedback]="true"
        (strengthChange)="passwordStrength = $event"
        [ngClass]="'psm'"
      ></password-strength-meter>
      <div class="turnstile">
        <div class="loading" [class.hide]="turnstile_load_ad()"></div>
        <ngx-turnstile
          siteKey="0x4AAAAAAAktK1j8mEx83MSX"
          (resolved)="onTurnstileResolved($event)"
          theme="auto"
          data-size="flexible"
          [tabIndex]="0"
          appearance="execute"
        ></ngx-turnstile>
      </div>
      <button
        class="button primary fw-bold"
        (click)="registerUser()"
        [disabled]="loading$ | async"
      >
        Register
      </button>
    </div>
  </div>
  <mat-progress-bar
    [class.visually-hidden]="(loading$ | async) === false"
    class="top-loading-bar"
    mode="indeterminate"
  ></mat-progress-bar>
</div>
